export const teamKeys = {
    all: ['team'] as const,
    list: (centerId: string, status: 'active' | 'all') =>
        [...teamKeys.all, 'list', centerId, status] as const,
    detail: (centerId: string, teamId: string) =>
        [...teamKeys.all, 'detail', centerId, teamId] as const,
    superAdminAnalytics: (superAdminId: string, from: string, to: string, centerIds?: string[]) =>
        [...teamKeys.all, 'superAdmin', 'analytics', superAdminId, from, to, centerIds ?? []] as const,
    superAdminBreakdown: (superAdminId: string, teamId: string, from: string, to: string) =>
        [...teamKeys.all, 'superAdmin', 'breakdown', superAdminId, teamId, from, to] as const,
};
